import React from 'react'
import './index.sass'

const ButtonClose = ({ onHandleClick }) => (
  <button className="btn btn-close" onClick={onHandleClick} />
)

export default ButtonClose
